'use strict';
const observable = require('@mindmup/mapjs-core/src/util/observable'),
	ThemeV2 = require('@mindmup/mapjs-core/src/theme/theme-v2'),
	mergeThemesV2 = require('@mindmup/mapjs-core/src/theme/merge-themes-v2'),
	themesIndexImpl = require('@mindmup/mapjs-core/src/themes/index'),
	getValueForKeyArray = require('@mindmup/js-utils/src/get-value-for-key-array'),
	setValueForKeyArray = require('@mindmup/js-utils/src/set-value-for-key-array'),
	themeToDictionary = require('@mindmup/mapjs-core/src/theme/theme-to-dictionary');

module.exports = function MapThemeModel(mapModel, optional) {
	let theme;
	const dispatcher = observable(this),
		themesIndex = (optional && optional.themesIndex) || themesIndexImpl,
		defaultTheme = themesIndex.default,
		autoThemedIdeaUtils = (optional && optional.autoThemedIdeaUtils) || require('@mindmup/mapjs-core/src/content/auto-themed-idea-utils'),
		getContext = function (themeId, themeJson, themeOverridesJson) {
			const context = {
				theme: !!themeId && themeId,
				allowThemeOverrides: themeJson && !themeJson.blockThemeOverrides
			};
			if (themeOverridesJson) {
				context.themeOverrides = themeOverridesJson;
			}
			return context;
		},
		dispatchContext = function (themeId, themeJson, themeOverridesJson) {
			dispatcher.dispatchEvent('themesContext', getContext(themeId, themeJson, themeOverridesJson));
		},
		setThemeWithOverride = (themeId, themeOverride) => {
			themeId = themeId || 'default';
			const selectedTheme = themesIndex[themeId],
				mergedThemeJson = mergeThemesV2({defaultTheme, selectedTheme, themeOverride});
			if (!mergedThemeJson) {
				return;
			}
			theme = new ThemeV2(mergedThemeJson);
			dispatcher.dispatchEvent('themeJSONChanged', mergedThemeJson);
			dispatchContext(themeId, mergedThemeJson, themeOverride);
		},
		getTheme = (themeId) => {
			if (!themeId) {
				return theme;
			}
			const activeContent = mapModel.getIdea(),
				themeOverride = activeContent && activeContent.getAttr('themeOverrides'),
				selectedTheme = themesIndex[themeId],
				mergedThemeJson = mergeThemesV2({defaultTheme, selectedTheme, themeOverride});
			return new ThemeV2(mergedThemeJson);

		},
		setThemeOverrides = (themeOverrides) => {
			if (!mapModel.isEditingEnabled()) {
				return false;
			}
			const activeContent = mapModel.getIdea(),
				themeId = (activeContent && activeContent.getAttr('theme')) || 'default';
			if (!activeContent) {
				return false;
			}

			setThemeWithOverride(themeId, themeOverrides);
			activeContent.batch(() => {
				activeContent.updateAttr(activeContent.id, 'theme', themeId);
				activeContent.updateAttr(activeContent.id, 'themeOverrides', themeOverrides);
				autoThemedIdeaUtils.recalcIdeasAutoNodeAttrs(activeContent, theme, activeContent, 0, 0);
			});
		},
		cloneCurrentOverrides = () => {
			const activeContent = mapModel.getIdea(),
				currentThemeOverrides = (activeContent && activeContent.getAttr('themeOverrides')) || {},
				clonedOverrides = JSON.parse(JSON.stringify(currentThemeOverrides));
			return themeToDictionary(clonedOverrides);
		},
		setTheme = (themeId, force) => {
			if ((!force && !mapModel.isEditingEnabled()) || !themeId) {
				return false;
			}

			const activeContent = mapModel.getIdea(),
				themeOverrides = activeContent && activeContent.getAttr('themeOverrides');

			if (!activeContent) {
				return false;
			}
			setThemeWithOverride(themeId, themeOverrides);

			activeContent.batch(() => {
				activeContent.updateAttr(activeContent.id, 'theme', themeId);
				autoThemedIdeaUtils.recalcIdeasAutoNodeAttrs(activeContent, theme, activeContent, 0, 0);
			});
		},
		start = () => {
			setThemeWithOverride('default');
		},
		getThemeAttribute = (attrPath, styles, postfixes) => {
			const combinedTheme = getTheme();
			return combinedTheme && combinedTheme.attributeValue(attrPath, styles, postfixes);
		},
		overrideThemeAttribute = (attrPath, value) => {
			const themeOverrides = cloneCurrentOverrides();
			if (value === undefined && !getValueForKeyArray({target: themeOverrides, keyArray: attrPath})) {
				return;
			}
			setValueForKeyArray({target: themeOverrides, keyArray: attrPath, value});
			setThemeOverrides(themeOverrides);
		},
		removeThemeOverrides = () => {
			setThemeOverrides(false);
		},
		getNumberOfLevels = () => {
			const currentThemeOverrides = cloneCurrentOverrides();
			return currentThemeOverrides.numberOfLevels || 4;
		},
		setNumberOfLevels = () => {
			const currentThemeOverrides = cloneCurrentOverrides();
			currentThemeOverrides.numberOfLevels = getNumberOfLevels() + 1;
			setThemeOverrides(currentThemeOverrides);
		},
		addLevel  = () => {
			setNumberOfLevels(getNumberOfLevels() + 1);
			dispatcher.dispatchEvent('levelAdded');
		},
		getLevels = () => {
			const numberOfLevels = getNumberOfLevels(),
				levels = {
					level_1: 'root nodes'
				};
			for (let i = 0; i < numberOfLevels;i++) {
				levels[`level_${i + 2}`] = `level ${i + 1}`;
			}
			return levels;
		},
		themeChanged = (themeId) => {
			setTheme(themeId, true);
			dispatcher.dispatchEvent('themeChanged');
		};

	mapModel.addEventListener('themeChanged', themeChanged);
	mapModel.setThemeSource(getTheme);

	Object.freeze(Object.assign(this, {setTheme, setThemeOverrides, getTheme, start, getThemeAttribute, overrideThemeAttribute, removeThemeOverrides, addLevel, getLevels}));
};

